<template>
  <a-modal
    title='可视化图表'
    :visible='visible'
    :confirm-loading='confirmLoading'
    @ok='handleOk'
    @cancel='handleCancel'
    width='800'
  >
    <div class='bigbox'>
      <div class='productName'>
        <div v-show='showDayTitle'><h3>日期：{{ startTime }}</h3></div>
        <div v-show='displayColumnBox' class='contentbox1' style='display: flex;flex-direction: column'>
          <h3>日期：{{ startTime }}~{{ endTime }}</h3>
          <h3>转化数值</h3>
          <div class='branchDatechartone' style='width:90vw; height: 800px; margin-bottom: 100px'></div>
          <h3>转化率</h3>
          <div class='branchDatecharttwo' style='width:90vw; height: 800px;margin-bottom: 100px'></div>
          <h3>成本金额</h3>
          <!--    总消费-->
          <div style='font-size: 14px; margin-bottom: 10px' v-for='item in topshowTitalSumption' :key='item'>
            <div>{{ item }}</div>
          </div>
          <div class='branchDatechartthree' style='width:90vw; height: 800px;'></div>
        </div>
        <div v-show='displayRowBox' class='contentbox2'
             style='display: flex;flex-direction: row;justify-content: space-around;'>
          <div class='branchdate-chart-one' style='width:600px; height: 400px;'></div>
          <div class='branchdate-chart-two' style='width: 800px; height: 400px;'></div>
          <div>
            <h3 style='margin-left: 20px;margin-top: -32px;'>总金额：{{ TotalConsumption[0] }}</h3>
            <div class='branchdate-chart-three' style='width: 500px; height: 400px;'></div>
          </div>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { getAppAllCountForDate } from '@/webpublicapi/order'

export default {
  data() {
    return {
      displayColumnBox: true,
      displayRowBox: true,
      visible: false,
      confirmLoading: true,
      showDayTitle: false,//只有一天数据的时候展示日期
      ColumnFigureOneOneday: [],
      ColumnFigureOne: [[], [], [], [], [], []],//折线图1数据
      ColumnFigureOneNum: [],//折线图1柱子数
      echartsShowFlag: true,//折线图1柱子上是否显示文字
      ColumnFigureTwoOneday: [],
      ColumnFigureTwo: [[], [], [], [], [], []],//折线图2数据
      ColumnFigureTwoNum: [],//折线图2柱子数
      ColumnFigureThreeNum: [],//折线图2柱子数
      TotalConsumption: [],//存储总花费的数组
      ColumnFigureThree: [[], [], [], [], [], []],//柱状图3数据
      topshowTitalSumption: [],//成本图顶部显示每个月的消费
      PieChartData: [],//存储只有一天数据显示饼状图所需要的数据
      startTime: '',
      endTime: ''
    }
  },
  created() {
    console.log('created')
  },
  mounted() {
    console.log('进入branchallcount页面')
    this.confirmLoading = true
  },
  methods: {
    clearEcharts() {
      console.log('开始清空')
      this.$echarts.init(document.querySelector('.branchDatechartone')).clear()
      this.$echarts.init(document.querySelector('.branchDatecharttwo')).clear()
      this.$echarts.init(document.querySelector('.branchDatechartthree')).clear()
      this.$echarts.init(document.querySelector('.branchdate-chart-one')).clear()
      this.$echarts.init(document.querySelector('.branchdate-chart-two')).clear()
      this.$echarts.init(document.querySelector('.branchdate-chart-three')).clear()
      this.ColumnFigureTwoOneday = []
      this.ColumnFigureOneOneday = []
      this.PieChartData = []
      console.log('完成清空')
    },
    openModal() {
      console.log('open')
      this.visible = true
    },
    handleOk() {
      this.visible = false
    },
    handleCancel() {
      this.visible = false
    },
    //请求图的数据
    sendRequest(query) {
      // 发送请求的逻辑
      query.pageSize = 100
      console.log('准备发请求的参数', query)
      getAppAllCountForDate(query).then((res) => {
        console.log('请求的结果', res)
        if (res.code === 1000) {
          this.confirmLoading = false
          this.startTime = res.data.rows[res.data.rows.length - 1].datadt
          this.endTime = res.data.rows[0].datadt
          const datalist = res.data.rows
          console.log('dataList查询出来的每天的数据', datalist)
          //总消费
          const titalmoneyArray = (datalist.map(datalist => datalist.fee))
          titalmoneyArray.reverse()
          this.TotalConsumption = titalmoneyArray
          console.log('总消费this.TotalConsumption', this.TotalConsumption)
          //获取每一天
          const datArray = (datalist.map(datalist => datalist.datadt))
          datArray.reverse()
          let noYear = datArray.map(datArray => datArray.slice(5))
          this.topshowTitalSumption = noYear.map((date, index) => `${date} 总消费:  ${this.TotalConsumption[index]}`)
          // console.log('//成本图顶部显示每个月的消费', this.topshowTitalSumption)//成本图顶部显示每个月的消费
          noYear.unshift('daydata')
          // this.topshowTitalSumption.unshift('daydata')
          this.ColumnFigureOne[0] = noYear
          this.ColumnFigureTwo[0] = noYear
          // this.ColumnFigureThree[0] = this.topshowTitalSumption
          this.ColumnFigureThree[0] = noYear

          // 图一数据----------------------------------------------------------------------------------------
          const installArray = (datalist.map(datalist => datalist.installs))
          installArray.reverse()
          installArray.unshift('安装')
          this.ColumnFigureOne[1] = installArray
          const regCountArray = (datalist.map(datalist => datalist.regCount))
          regCountArray.reverse()
          regCountArray.unshift('注册')
          this.ColumnFigureOne[2] = regCountArray
          const subCountArray = (datalist.map(datalist => datalist.subCount))
          subCountArray.reverse()
          subCountArray.unshift('申贷')
          this.ColumnFigureOne[3] = subCountArray
          const approvalCountArray = (datalist.map(datalist => datalist.approvalCount))
          approvalCountArray.reverse()
          approvalCountArray.unshift('通过')
          this.ColumnFigureOne[4] = approvalCountArray
          const loanCountArray = (datalist.map(datalist => datalist.loanCount))
          loanCountArray.reverse()
          loanCountArray.unshift('放款')
          this.ColumnFigureOne[5] = loanCountArray
          console.log('第一个柱状图的数据', this.ColumnFigureOne)

          this.ColumnFigureOneNum = []
          this.ColumnFigureTwoNum = []
          this.ColumnFigureThreeNum = []

          for (var j = 1; j < this.ColumnFigureOne.length; j++) {
            this.ColumnFigureOneOneday.push(this.ColumnFigureOne[j][1])
          }
          console.log('只有一个日期的柱状图一的数据', this.ColumnFigureOneOneday)


          //图二数据----------------------------------------------------------------------------------------
          const irRateArray = (datalist.map(datalist => datalist.irRate))
          for (var i = 0; i < irRateArray.length; i++) {
            irRateArray[i] = irRateArray[i].replace('%', '')
          }
          irRateArray.reverse()
          irRateArray.unshift('安装-注册转化率')
          this.ColumnFigureTwo[1] = irRateArray
          const rsRateArray = (datalist.map(datalist => datalist.rsRate))
          for (var i = 0; i < rsRateArray.length; i++) {
            rsRateArray[i] = rsRateArray[i].replace('%', '')
          }
          rsRateArray.reverse()
          rsRateArray.unshift('注册-申请转化率')
          this.ColumnFigureTwo[2] = rsRateArray
          const saRateArray = (datalist.map(datalist => datalist.saRate))
          for (var i = 0; i < saRateArray.length; i++) {
            saRateArray[i] = saRateArray[i].replace('%', '')
          }
          saRateArray.reverse()
          saRateArray.unshift('申请-通过转化率')
          this.ColumnFigureTwo[3] = saRateArray
          const slRateArray = (datalist.map(datalist => datalist.slRate))
          for (var i = 0; i < slRateArray.length; i++) {
            slRateArray[i] = slRateArray[i].replace('%', '')
          }
          slRateArray.reverse()
          slRateArray.unshift('申请-放款转化率')
          this.ColumnFigureTwo[4] = slRateArray
          const alRateArray = (datalist.map(datalist => datalist.alRate))
          for (var i = 0; i < alRateArray.length; i++) {
            alRateArray[i] = alRateArray[i].replace('%', '')
          }
          alRateArray.reverse()
          alRateArray.unshift('通过-放款转化率')
          this.ColumnFigureTwo[5] = alRateArray
          console.log('第二个柱状图的数据', this.ColumnFigureTwo)

          for (var j = 1; j < this.ColumnFigureTwo.length; j++) {
            this.ColumnFigureTwoOneday.push(this.ColumnFigureTwo[j][1])
          }
          console.log('只有一个日期的柱状图二的数据', this.ColumnFigureTwoOneday)


          //图三数据----------------------------------------------------------------------------------------
          const InstallationCostArray = (datalist.map(datalist => datalist.installFee))
          InstallationCostArray.reverse()
          InstallationCostArray.unshift('安装单价')
          this.ColumnFigureThree[1] = InstallationCostArray
          const registerCostArray = (datalist.map(datalist => datalist.regFee))
          registerCostArray.reverse()
          registerCostArray.unshift('注册单价')
          this.ColumnFigureThree[2] = registerCostArray

          const ApplyloanCostArray = (datalist.map(datalist => datalist.subFee))
          ApplyloanCostArray.reverse()
          ApplyloanCostArray.unshift('申贷单价')
          this.ColumnFigureThree[3] = ApplyloanCostArray
          const PassCostArray = (datalist.map(datalist => datalist.approvalFee))
          PassCostArray.reverse()
          PassCostArray.unshift('通过单价')
          this.ColumnFigureThree[4] = PassCostArray
          const givemoneyCostArray = (datalist.map(datalist => datalist.loanFee))
          givemoneyCostArray.reverse()
          givemoneyCostArray.unshift('放款单价')
          this.ColumnFigureThree[5] = givemoneyCostArray


          console.log('第三个柱状图的数据', this.ColumnFigureThree)

          for (var j = 1; j < this.ColumnFigureThree.length; j++) {
            this.PieChartData.push(this.ColumnFigureThree[j][1])
          }
          console.log('只有一个日期的柱状图三的数据', this.PieChartData)


          this.ColumnFigureOneNum = []
          this.ColumnFigureTwoNum = []
          this.ColumnFigureThreeNum = []


          //设置柱状图条条的个数
          for (let i = 0; i < this.ColumnFigureOne[0].length - 1; i++) {
            let obj1 = {
              type: 'bar',
              label: {
                show: this.echartsShowFlag,
                position: 'top', // 标签位置
                color: 'black', // 文字颜色
                fontSize: 16,// 文字大小
                fontWeight: 'bold',
                formatter: function(params) {
                  if (params.value[i + 1] == 0.00 || params.value[i + 1] == 0) {
                    return '{a|' + params.value[i + 1] + '\n' + '}' + '{c|' + params.dimensionNames[i + 1] + '}'
                  } else {
                    return '{b|' + params.value[i + 1] + '\n' + '}' + '{d|' + params.dimensionNames[i + 1] + '}'

                  }
                },
                rich: {
                  a: {
                    color: 'red',
                    align: 'center',
                    fontSize: 16
                  },
                  b: {
                    color: 'black',
                    align: 'center',
                    // fontWeight: 'bold',
                    fontSize: 16
                  },
                  c: {
                    fontSize: 11,
                    color: 'red',
                    align: 'center'
                  },
                  d: {
                    fontSize: 11,
                    color: 'black',
                    align: 'center'
                  }
                }
              }
            }
            let obj2 = {
              type: 'bar',
              // barGap:'100%',
              label: {
                show: this.echartsShowFlag,
                position: 'top', // 标签位置
                color: 'black', // 文字颜色
                fontSize: 16,// 文字大小
                fontWeight: 'bold',
                formatter: function(params) {
                  // console.log('params要怎么修改呢？？', params)
                  if (params.value[i + 1] == 0.00 || params.value[i + 1] == 0) {
                    return '{a|' + params.value[i + 1] + '%' + '\n' + '}' + '{c|' + params.dimensionNames[i + 1] + '}'
                  } else {
                    return '{b|' + params.value[i + 1] + '%' + '\n' + '}' + '{d|' + params.dimensionNames[i + 1] + '}'
                  }

                },
                rich: {
                  a: {
                    color: 'red',
                    fontSize: 14,
                    align: 'center'
                  },
                  b: {
                    color: 'black',
                    fontSize: 14,
                    align: 'center'
                  },
                  c: {
                    color: 'red',
                    fontSize: 11,
                    align: 'center'
                  },
                  d: {
                    color: 'black',
                    fontSize: 11,
                    align: 'center'
                  }

                }
              }
            }

            this.ColumnFigureOneNum.push(obj1)
            this.ColumnFigureTwoNum.push(obj2)
            this.ColumnFigureThreeNum.push(obj1)
          }
          //判断画哪个图？
          // 数据处理,画图
          if (this.ColumnFigureOne[0].length - 1 == 1) {
            this.drawOneDay()
          } else if (this.ColumnFigureOne[0].length - 1 <= 7) {
            //7天以内柱状图
            this.drawChart()
            //7天以上折线图
          } else {
            //折线图
            this.drawLineChart()
          }
        } else {
        }

      }).catch(e => {

      })
    },
    //一天的画法
    drawOneDay() {
      console.log('调用了1天画图的方法')
      this.showDayTitle = true
      this.displayColumnBox = false
      this.displayRowBox = true
      //柱状图1----------------------------------------------------------------------------------------
      var chartDom1 = document.querySelector('.branchdate-chart-one')
      console.log('chartDom1', chartDom1)
      var myChart1 = this.$echarts.init(chartDom1)
      var option1
      option1 = {
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: ['安装', '注册', '申贷', '通过', '放款'],
          axisTick: {
            alignWithLabel: true
          }
        },
        yAxis: {
          type: 'value'

        },
        series: [
          {
            data: this.ColumnFigureOneOneday,
            type: 'bar'
          },
          {
            data: this.ColumnFigureOneOneday,
            type: 'line',
            label: {
              show: this.echartsShowFlag,
              position: 'top',
              fontWeight: 'bold'
            }
          }
        ]
      }
      option1 && myChart1.setOption(option1)
      //柱状图2--------------------------------------------------------------------------------------------
      var chartDom2 = document.querySelector('.branchdate-chart-two')
      var myChart2 = this.$echarts.init(chartDom2)
      var option2
      option2 = {
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: ['安装-注册转化率', '注册-申请转化率', '申请-通过转化率', '申请-放款转化率', '通过-放款转化率'],
          axisTick: {
            alignWithLabel: true
          }

        },
        yAxis: {
          type: 'value',
          axisLabel: {
            formatter: function(value) {
              return value + '%'
            }
          }
        },
        series: [
          {
            data: this.ColumnFigureTwoOneday,
            type: 'bar'
          },
          {
            data: this.ColumnFigureTwoOneday,
            type: 'line',
            label: {
              show: this.echartsShowFlag,
              position: 'top',
              fontWeight: 'bold',
              formatter: function(params) {
                return params.value + '%'
              }
            }
          }
        ]
      }
      option2 && myChart2.setOption(option2)
      //柱状图3--------------------------------------------------------------------------------------------------
      var chartDom3 = document.querySelector('.branchdate-chart-three')
      var myChart3 = this.$echarts.init(chartDom3)
      var option3
      option3 = {
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: ['安装单价', '注册单价', '申贷单价', '通过单价', '放款单价'],
          axisTick: {
            alignWithLabel: true
          }
        },
        yAxis: {
          type: 'value'
        },
        series: [
          {
            data: this.PieChartData,
            type: 'bar'
          },
          {
            data: this.PieChartData,
            type: 'line',
            label: {
              show: this.echartsShowFlag,
              position: 'top',
              fontWeight: 'bold'
            }
          }
        ]
      }
      option3 && myChart3.setOption(option3)
    },
    //大于1天不超过7天的rcharts画图合集
    drawChart() {
      console.log('调用了2~7天画图的方法')
      this.showDayTitle = false
      this.displayColumnBox = true
      this.displayRowBox = false
      //柱状图一------------------------------------------------------------------------
      let optionone = {}
      let chartDomone = document.querySelector('.branchDatechartone')
      console.log('chartDomone', chartDomone)
      let myChartone = this.$echarts.init(chartDomone)
      console.log('myChartone', myChartone)
      optionone = {
        toolbox: {
          feature: {
            saveAsImage: {
              right: '20px', // 设置保存图片按钮的位置为距离容器右边缘20px
              top: '20px' // 设置保存图片按钮的位置为距离容器顶部20px
            }
          }
        },
        grid: {
          top: '18%'    // 上边距
        },
        legend: {},
        tooltip: {},
        dataset: {
          source: this.ColumnFigureOne
        },
        xAxis: { type: 'category' },
        yAxis: {
          position: 'left'
        },
        series: this.ColumnFigureOneNum
      }
      optionone && myChartone.setOption(optionone)


      //柱状图二---------------------------------------------------------------------------
      let optiontwo = {}
      let chartDomtwo = document.querySelector('.branchDatecharttwo')
      let myCharttwo = this.$echarts.init(chartDomtwo)
      optiontwo = {
        grid: {
          top: '18%'    // 上边距
        },
        legend: {},
        tooltip: {
          formatter: function(params) {
            return params.marker + ' ' + params.seriesName + ' ' + ' ' + params.name + ':' + '<b>' + params.data[params.seriesIndex + 1] + '%' + '</b>'
          }
        },

        dataset: {
          source: this.ColumnFigureTwo

        },

        xAxis: { type: 'category' },
        yAxis: {
          position: 'left',
          axisLabel: {
            formatter: function(value) {
              return value + '%'
            }
          }
        },
        series: this.ColumnFigureTwoNum
      }
      optiontwo && myCharttwo.setOption(optiontwo)
      //饼图三-------------------------------------------------------
      const chartDomthree = document.querySelector('.branchDatechartthree')
      const myChartthree = this.$echarts.init(chartDomthree)
      const optionthree = {
        grid: {
          top: '18%'    // 上边距
        },
        legend: {},
        dataset: {
          source: this.ColumnFigureThree

        },
        xAxis: { type: 'category' },
        yAxis: {
          position: 'left'
        },
        series: this.ColumnFigureThreeNum
      }
      optionthree && myChartthree.setOption(optionthree)

    },
    //超过七天的画法
    drawLineChart() {
      console.log('超过7天画图的方法')
      this.showDayTitle = false
      this.displayColumnBox = true
      this.displayRowBox = false
      console.log('ColumnFigureOne', this.ColumnFigureOne)
      console.log('ColumnFigureTwo', this.ColumnFigureTwo)

      /*处理折线图一的数据*/
      var xDayData = (this.ColumnFigureOne[0])//月份
      xDayData.shift()
      console.log('x轴数据--->', xDayData)

      var installData = (this.ColumnFigureOne[1])
      installData.shift()
      console.log('安装数据--->', installData)

      var registerData = (this.ColumnFigureOne[2])
      registerData.shift()
      console.log('注册数据--->', registerData)

      var subData = (this.ColumnFigureOne[3])
      subData.shift()
      console.log('申贷数据--->', subData)

      var passData = (this.ColumnFigureOne[4])
      passData.shift()
      console.log('通过数据--->', passData)

      var giveMoneyData = (this.ColumnFigureOne[5])
      giveMoneyData.shift()
      console.log('放款数据--->', giveMoneyData)

      //折线图一---------------------------------------------------------------------------------
      let optionone = {}
      let chartDomone = document.querySelector('.branchDatechartone')
      let myChartone = this.$echarts.init(chartDomone)

      console.log('拿到的dom是什么？', chartDomone)
      optionone = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['安装', '注册', '申贷', '通过', '放款']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xDayData//月份
        },
        yAxis: {
          type: 'value'
          // position: 'right'
        },
        series: [
          {
            name: '安装',
            type: 'line',

            data: installData
          },
          {
            name: '注册',
            type: 'line',

            data: registerData
          },
          {
            name: '申贷',
            type: 'line',

            data: subData
          },
          {
            name: '通过',
            type: 'line',
            data: passData
          },
          {
            name: '放款',
            type: 'line',
            data: giveMoneyData
          }

        ]
      }
      optionone && myChartone.setOption(optionone)
      /*处理折线图二的数据*/

      var DataOne = (this.ColumnFigureTwo[1])
      DataOne.shift()
      console.log('安装-注册转化率--->', DataOne)

      var DataTwo = (this.ColumnFigureTwo[2])
      DataTwo.shift()
      console.log('注册-申请转化率--->', DataTwo)

      var DataThree = (this.ColumnFigureTwo[3])
      DataThree.shift()
      console.log('申请-通过转化率--->', DataThree)

      var DataFour = (this.ColumnFigureTwo[4])
      DataFour.shift()
      console.log('申请-放款转化率--->', DataFour)


      var DataFive = (this.ColumnFigureTwo[5])
      DataFive.shift()
      console.log('通过-放款转化率--->', DataFive)


      //折线图二---------------------------------------------------------------------------------
      let optiontwo = {}
      let chartDomtwo = document.querySelector('.branchDatecharttwo')
      let myCharttwo = this.$echarts.init(chartDomtwo)
      optiontwo = {

        title: {
          // text: 'Stacked Line'
        },
        tooltip: {
          trigger: 'axis',
          formatter: function(param) {
            var content = ''
            param.forEach(item => {
              content += '<div style="padding:6px;">' + item.marker + item.seriesName + ':' + item.value + '%' + '</div>'
            })
            return content
          }
        },
        legend: {
          data: ['安装-注册转化率', '注册-申请转化率', '申请-通过转化率', '申请-放款转化率', '通过-放款转化率']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xDayData//月份
        },
        yAxis: {
          type: 'value',
          // position: 'right'
          axisLabel: {
            formatter: function(value) {
              return value + '%'
            }
          }
        },
        series: [
          {
            name: '安装-注册转化率',
            type: 'line',
            data: DataOne
          },
          {
            name: '注册-申请转化率',
            type: 'line',

            data: DataTwo
          },
          {
            name: '申请-通过转化率',
            type: 'line',
            data: DataThree
          },
          {
            name: '申请-放款转化率',
            type: 'line',
            data: DataFour
          },
          {
            name: '通过-放款转化率',
            type: 'line',
            data: DataFive
          }

        ]
      }
      optiontwo && myCharttwo.setOption(optiontwo)


      //折线图三---------------------------------------------------------------------------------
      /*处理折线图三的数据*/

      var DataThreeOne = (this.ColumnFigureThree[1])
      DataThreeOne.shift()
      console.log('安装单价--->', DataThreeOne)

      var DataThreeTwo = (this.ColumnFigureThree[2])
      DataThreeTwo.shift()
      console.log('注册单价--->', DataThreeTwo)

      var DataThreeThree = (this.ColumnFigureThree[3])
      DataThreeThree.shift()
      console.log('申贷单价--->', DataThreeThree)

      var DataThreeFour = (this.ColumnFigureThree[4])
      DataThreeFour.shift()
      console.log('通过单价--->', DataThreeFour)

      var DataThreeFive = (this.ColumnFigureThree[5])
      DataThreeFive.shift()
      console.log('放款单价--->', DataThreeFive)


      let optionthree = {}
      let chartDomthree = document.querySelector('.branchDatechartthree')
      let myChartthree = this.$echarts.init(chartDomthree)
      optionthree = {

        title: {},
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: ['安装单价', '注册单价', '申贷单价', '通过单价', '放款单价']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xDayData//月份
        },
        yAxis: {
          type: 'value'
          // position: 'right'
        },
        series: [
          {
            name: '安装单价',
            type: 'line',
            data: DataThreeOne
          },
          {
            name: '注册单价',
            type: 'line',
            data: DataThreeTwo
          },
          {
            name: '申贷单价',
            type: 'line',
            data: DataThreeThree
          },
          {
            name: '通过单价',
            type: 'line',
            data: DataThreeFour
          },
          {
            name: '放款单价',
            type: 'line',
            data: DataThreeFive
          }

        ]
      }
      optionthree && myChartthree.setOption(optionthree)
    }
  }
}
</script>

<style>
</style>